import React, { useState } from 'react';
import Select from 'react-select';
import CodeBlock from "@components/codeblock"


import '@theme/emptystates/master.css'

// The following is pretty self explanatory,
// however ensure that your codefield is wrapped in ""
// Otherwise React will not pick this up as a string and throw and error.

const options = [
  {
    value: 'empty bag',
    label: 'Bag',
    codeField: `
<div id="emptyState" class="emptystate bag">
  <div class="emptyStateImage">
    <img src="https://www.freemans.com/Common/pix/emptystate/empty_bag.png" />
  </div>
  <div class="header">It's empty!</div>
  <div class="text">There are no items in your bag right now.</div>
 <a href="#/"><button class="primary">Start Shopping</button></a>
</div> 
`
  },
  {
    value: 'saved items',
    label: 'Saved Items',
    codeField: `
<div id="emptyState" class="emptystate saveditems">
  <div class="emptyStateImage">
    <img src="https://www.freemans.com/Common/pix/emptystate/empty_my_saves.png" />
  </div>
  <div class="header">You don't have any saved items</div>
  <div class="text">Like an item you see? Tap the heart icon to save it.</div>
 <a href="#/"><button class="primary">Find Things to Save</button></a>
</div> 
`
  },
  {
    value: 'not found',
    label: 'Not Found (500)',
    codeField: `
<div id="emptyState" class="emptystate notfound">
  <div class="emptyStateImage">
    <img src="https://www.freemans.com/Common/pix/emptystate/page_not_found_500.png" />
  </div>
  <div class="header">Oops! Somethings wrong</div>
  <div class="text">It's not something you’ve done, It's our fault and we are working on fixing it. </div>
 <a href="#/"><button class="primary">Return to Homepage</button></a>
</div> 
`
  },
  {
    value: 'not found two',
    label: 'Not Found (404)',
    codeField: `
<div id="emptyState" class="emptystate notfound">
  <div class="emptyStateImage">
    <img src="https://www.freemans.com/Common/pix/emptystate/page_not_found_404.png" />
  </div>
  <div class="header">Oops! Somethings wrong</div>
  <div class="text">We can't seem to find the page that you are looking for.</div>
 <a href="#/"><button class="primary">Return to Homepage</button></a>
</div> 
`
  },
  {
    value: 'order history',
    label: 'Order History',
    codeField: `
<div id="emptyState" class="emptystate orderhistory">
  <div class="emptyStateImage">
    <img src="https://www.freemans.com/Common/pix/emptystate/order_history.png" />
  </div>
  <div class="header">There's nothing here</div>
  <div class="text">There are no orders in your order history.</div> 
</div> 
`
  },
  {
    value: 'no returns',
    label: 'No Returns',
    codeField: `
<div id="emptyState" class="emptystate noreturns">
  <div class="emptyStateImage">
    <img src="https://www.freemans.com/Common/pix/emptystate/empty_returns.png" />
  </div>
  <div class="header">You don't have any returnable items</div>
  <div class="text">You can book returns for items received in the last 14 days.</div> 
  <a href="#/"><button class="primary">Returns Help</button></a>
</div> 
`
  },
  ];

  
const defaultSate = options[0].codeField


function EmptyStates() {
  //  Please ensure that your useState value contains the default value for your component
  // Otherwise nothing will show on initial render.
    const [selectedValue, setSelectedValue] = useState(defaultSate);
 
    const handleChange = e => {
      setSelectedValue(e.codeField);
    }
  
    return (
    <>
        <Select
         className="slDrp"
          placeholder="Select Option"
          value={options.filter(obj => obj.codeField === selectedValue)} // set selected value
          onChange={handleChange}
          options={options}
        />
        <CodeBlock value={selectedValue} live={true}>{selectedValue}</CodeBlock>
    </>
    );
    }

export default EmptyStates


